import { TRESPONSE_TNA_BOARD_LISTING, TTnaEntityGroupData, TTnaEntityData, TTnaElementData } from '@monorepo/types';
import { TIMELINE_MODEL } from '../timeline.model';
import { TEntityActions, TRange, TTimelineModel } from '../timeline.types';
import { getStripColorPatternMap } from '../timeline.utils';

export const TNA_MODEL = {
  createModel: (tnaBoardResponse: TRESPONSE_TNA_BOARD_LISTING) => {
    const timelineModel = TIMELINE_MODEL.createTimelineModel<TTnaEntityGroupData, TTnaEntityData, TTnaElementData>(
      {
        boardViewType: 'WEEKLY',
      },
      [tnaBoardResponse.tnaBoardStripList],
      (group) => {
        const entities = group.map((v) => {
          const x = v.stripInfo.stripRanges.map((s) => {
            const stripMetadata = tnaBoardResponse.stripStatusMetadataMap[s.status];
            const { color, hasMask } = getStripColorPatternMap(stripMetadata.stripColor);
            return {
              type: 'STRIP' as const,
              id: v.orderIdInfo.orderId,
              name: stripMetadata.displayName,
              range: s.range as TRange,
              stackCount: 0 as const,
              color: color,
              mask: hasMask,
              data: s,
              iconList: [],
            };
          });
          return {
            id: v.orderIdInfo.orderId,
            data: v,
            name: {
              displayTxt: v.orderIdInfo.userOrderId,
              isClickable: true,
            },
            elements: [
              ...x,
              {
                type: 'MARKER' as const,
                id: v.orderIdInfo.orderId,
                name: 'Latest Delivery',
                range: {
                  startDate: v.stripInfo.deliveryDateRange.endDate,
                  endDate: v.stripInfo.deliveryDateRange.endDate,
                } as TRange,
                stackCount: 1 as const,
                color: '#0028B8',
                mask: false,
              },
              {
                type: 'MARKER' as const,
                id: v.orderIdInfo.orderId,
                name: 'Earliest Delivery',
                range: {
                  startDate: v.stripInfo.deliveryDateRange.startDate,
                  endDate: v.stripInfo.deliveryDateRange.startDate,
                } as TRange,
                color: '#5277FF',
                stackCount: 1 as const,
                mask: false,
                isHalfDay: true,
              },
              ...(v.stripInfo.pcdTargetDate
                ? [
                    {
                      type: 'MARKER' as const,
                      id: v.orderIdInfo.orderId,
                      name: 'PCD Target Date',
                      range: {
                        startDate: v.stripInfo.pcdTargetDate,
                        endDate: v.stripInfo.pcdTargetDate,
                      } as TRange,
                      stackCount: 1 as const,
                      color: '#9C27B0',
                      mask: false,
                    },
                  ]
                : []),
              ...(v.stripInfo.pcdExpectedDate
                ? [
                    {
                      type: 'MARKER' as const,
                      id: v.orderIdInfo.orderId,
                      name: 'PCD Expected Date',
                      range: {
                        startDate: v.stripInfo.pcdExpectedDate,
                        endDate: v.stripInfo.pcdExpectedDate,
                      } as TRange,
                      stackCount: 1 as const,
                      color: '#FCBC69',
                      mask: false,
                    },
                  ]
                : []),
            ],
          };
        });

        return {
          id: '',
          name: '',
          data: group,
          entities,
          holidays: [],
        };
      },
    );

    return timelineModel;
  },

  chageView: (type: TTimelineModel['boardView']['boardViewType'], timelineModel: TTimelineModel) => {
    return TIMELINE_MODEL.changeTimelineType(type, timelineModel);
  },
};

export type TTnaEntityAction = TEntityActions<TTnaEntityGroupData, TTnaEntityData, TTnaElementData>;
export type TTnaTimelineModel = ReturnType<typeof TNA_MODEL.createModel>;
